import React from "react"
import { Archivetitle } from "./ArchiveTitle"
import { Description } from "./Description"
import { Pagination } from "./Pagination"
import { PostsList } from "./PostsList"
import AdContainer from "../AdContainer"
import { useThemeOptions } from "@gatsbywpthemes/gatsby-theme-blog-data/src/hooks"
import { Archivepost } from "./ArchivePost"
import CategoryCTA from "./CategoryCTA"
import clsx from "clsx"

export const landingPageCTAs = [
  {
    title: "Code Examples",
    description:
      "This section provides you small and well-documented Code examples for Beginners, Clear Your basic Concepts using this section.",
    textClasses: "text-[#18a46f] ",
    buttonClasses: "bg-[#18a46f]",
    bgClass: "bg-[#f1fdf8] dark:bg-gradient-to-r from-green-800 to-green-700",
    buttonTitle: "Explore",
    uri: "/category/code-examples",
  },
  {
    title: "Tutorials",
    description:
      "Advanced Tutorials for web and app development including, Vue, JavaScript, Laravel, Flutter, Golang, Python and more.",
    buttonTitle: "Explore",
    textClasses: "text-[#F55700]",
    buttonClasses: "bg-[#F55700]",
    bgClass: "bg-[#fef1f0] dark:bg-gradient-to-r from-orange-600 to-rose-600",
    uri: "/category/tutorials",
  },
  {
    title: "Errors Solved",
    description:
      "Detailed instructions to solve Real life errors in your code, Save your time and effort for googling using this section.",
    buttonTitle: "Explore",
    textClasses: "text-[#AA1994]",
    buttonClasses: "bg-[#AA1994]",
    bgClass: "bg-[#fbecf9] dark:bg-gradient-to-r from-purple-800 to-violet-900",
    uri: "/category/errors-solved",
  },
]

export const ArchiveContent = ({
  posts,
  ctx,
  name,
  description,
  isLandingPage,
}) => {
  const {
    archiveSidebarPosition: archiveSidebar,
    layoutWidth,
    widgetAreas: { sidebarWidgets },
  } = useThemeOptions()

  const hasSidebar = sidebarWidgets && archiveSidebar
  const archiveWidth = layoutWidth.archive

  const isFirstLandingPage = isLandingPage && ctx.humanPageNumber === 1
  const [firstPost, ...rest] = posts

  return (
    <div
      className={`mainContainer mx-auto ${hasSidebar
          ? `max-w-xl`
          : `${archiveWidth === "md"
            ? "max-w-md"
            : archiveWidth === "lg"
              ? "max-w-lg"
              : "max-w-xl"
          }`
        }`}
    >
      {name && <Archivetitle name={name} text="Posts for " className="mb-10" />}
      {description && (
        <Description description={description} className="mb-10" />
      )}

      {isFirstLandingPage && <Archivepost post={firstPost} isSeparated />}

      {isFirstLandingPage && (
        <div className="mt-6">
          <div className="adsbyvli" style={{ width:`720px`, height:`90px` }} data-ad-slot="vi_433439544"></div>
          
          <script dangerouslySetInnerHTML={{ __html: "(vitag.Init = window.vitag.Init || []).push(function () { viAPItag.display('vi_433439544') })" }} />
        </div>
      )}

      {isFirstLandingPage && (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 mt-16 mb-16 gap-8">
          {landingPageCTAs.map((values, index) => (
            <CategoryCTA key={values.title + index} {...values} />
          ))}
        </div>
      )}

      {isFirstLandingPage && (
        <p className="text-xl uppercase tracking-widest mb-4 font-bold md:pl-2">
          Latest posts
        </p>
      )}
      <div className={clsx(!isLandingPage && "card p-4")}>
        <PostsList posts={isLandingPage ? rest : posts} />
      </div>

      <Pagination ctx={ctx} />

      <div className="mt-12">
      <div className="adsbyvli" style={{ width:`720px`, height:`90px` }} data-ad-slot="vi_433439544"></div>
          
          <script dangerouslySetInnerHTML={{ __html: "(vitag.Init = window.vitag.Init || []).push(function () { viAPItag.display('vi_433439544') })" }} />
   
      </div>
    </div>
  )
}
